"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const _ActionTypes = require("./actionTypes");
const _revisionsActionTypes = require("../../revisions/actionTypes");
const _treeReducers = require("../tree/reducers");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
const statusLens = monocle.Lens.fromProp('status');
const folderTreeLens = monocle.Lens.fromProp('folderTree');
const revisionsLens = monocle.Lens.fromProp('revisions');
const currentRevisionLens = new monocle.Optional((data) => data.status === exports.FETCHED
    ? fp.option.some(data.currentRevision)
    : fp.option.none, (revision) => (data) => (Object.assign(Object.assign({}, data), { currentRevision: revision })));
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const revisionsActionTypes = _revisionsActionTypes.default(namespace);
    const treeReducers = _treeReducers.default(`preview-${namespace}`, 'NO_INHERIT_SELECTION');
    const initialState = {
        status: exports.STANDBY,
        folderTree: Object.assign({}, treeReducers.initialState),
        revisions: []
    };
    const methods = Object.keys(treeReducers.methods).reduce((acc, method) => {
        acc[method] = (state, action) => folderTreeLens.modify((treeState) => treeReducers.methods[method](treeState, action))(state);
        return acc;
    }, {});
    methods[ActionTypes.SET_PREVIEW_REVISION] = (state, action) => currentRevisionLens.set(action.revision)(state);
    methods[ActionTypes.GeneratePreviewActionTypes.GENERATE_PREVIEW_REQUEST] = (state, action) => {
        if (state.status === 'FETCHED' &&
            state.currentRevision &&
            action.payload === state.currentRevision.uuid) {
            return Object.assign(Object.assign({}, state), { currentRevision: Object.assign(Object.assign({}, state.currentRevision), { preview: { uuid: '', status: 'PROCESSING' } }) });
        }
        return state;
    };
    methods[ActionTypes.GeneratePreviewActionTypes.GENERATE_PREVIEW_FAILURE] = (state, action) => {
        if (state.status === 'FETCHED' &&
            state.currentRevision &&
            action.revisionUuid === state.currentRevision.uuid) {
            return Object.assign(Object.assign({}, state), { currentRevision: Object.assign(Object.assign({}, state.currentRevision), { preview: { uuid: '', status: 'FAILED' } }) });
        }
        return state;
    };
    methods[ActionTypes.GeneratePreviewActionTypes.GENERATE_PREVIEW_SUCCESS] = (state, action) => {
        if (state.status === 'FETCHED' &&
            state.currentRevision &&
            action.data.revisionUuid === state.currentRevision.uuid) {
            return Object.assign(Object.assign({}, state), { currentRevision: Object.assign(Object.assign({}, state.currentRevision), { preview: { uuid: action.data.uuid, status: action.data.status } }) });
        }
        return state;
    };
    methods[revisionsActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
    methods[revisionsActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
    methods[revisionsActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(revisionsLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return {
        reducer,
        initialState,
        methods,
        ActionTypes,
        GeneratePreviewActionTypes: ActionTypes.GeneratePreviewActionTypes
    };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map